module.exports = __webpack_public_path__ + "static/media/iphone.7d3064d9.webp";